import { orderBy } from 'lodash';
import { SurveyResults } from 'store/surveys';
import { formatPercents } from 'utils/format';
import { resolveTranslation } from 'utils/general';

export const retriesToAttempts = (retries: number) => retries + 1;

export const attemptsToRetries = (attempts: number) => attempts - 1;

export const parsedQuestionResults = ({
  results,
  userLng,
  defaultLng,
}: {
  results: SurveyResults;
  userLng: NonNullable<Parameters<typeof resolveTranslation>[1]>;
  defaultLng: Parameters<typeof resolveTranslation>[2];
}) =>
  orderBy(results.questions, ['index'], ['asc']).map((question, index) => {
    const translation = resolveTranslation(
      question.translations,
      userLng,
      defaultLng,
    );

    return {
      id: question.id,
      title: `${index + 1}.  ${translation?.text ?? ''}`,
      imageUrl: translation?.imageUrl ?? null,
      type: question.type,
      answers: orderBy(question.options, ['index'], ['asc']).map((option) => {
        const responseCount = question.optionResponseStats.reduce(
          (total, responseStats) => {
            if (responseStats.optionAnswer.includes(option.index)) {
              total += Number(responseStats.answeredByCount);
            }
            return total;
          },
          0,
        );

        const translation = resolveTranslation(
          option.translations,
          userLng,
          defaultLng,
        );

        return {
          index: option.index,
          label: translation?.text ?? '',
          imageId: translation?.imageId ?? null,
          imageUrl: translation?.imageUrl ?? null,
          isCorrect: translation?.isCorrect ?? false,
          responseCount,
          responsePercents: formatPercents(
            userLng,
            question.answeredByCount
              ? responseCount / question.answeredByCount
              : 0,
          ),
        };
      }),
    };
  });
